// extracted by mini-css-extract-plugin
export default {"mainContainer":"sku_mainContainer__IVh1o","iframe":"sku_iframe__K80yk","splitPane":"sku_splitPane__gEAC2","splitSash":"sku_splitSash__R2nKR","pane":"sku_pane__CVEdO"};